module.exports = __webpack_public_path__ + "img/logo-small.2b137e57.svg";